import { render, staticRenderFns } from "./InsurancesPlanDetailsAdd.vue?vue&type=template&id=5be84b22&scoped=true&"
import script from "./InsurancesPlanDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be84b22",
  null
  
)

export default component.exports